import { Input } from "antd";
import type React from "react";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

type Props = {
  onSearch?: (searchTerm: string) => void;
  displayValue?: string;
  initialValue?: string;
  placeholder?: string;
  className?: string;
};

export const SearchInput: React.FC<Props> = ({
  onSearch,
  initialValue = "",
  displayValue = "",
  placeholder = "",
  className = "",
}: Props) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const debouncedDoSearch = useDebouncedCallback(onSearch as any, 300);

  useEffect(() => {
    setSearchTerm(displayValue);
  }, [displayValue]);

  const onChangeHandler = (e) => {
    const newValue = e?.target?.value;
    setSearchTerm(newValue);
    debouncedDoSearch(newValue);
  };

  return (
    <div className={className}>
      <Input
        onChange={onChangeHandler}
        value={searchTerm}
        style={{
          borderRadius: "18px",
          background: "#d1d1d1",
        }}
        size="large"
        className="search-input pl-25 pr-25"
        prefix={<i className="fas fa-search mr-10" />}
        placeholder={placeholder || "Search..."}
      />
    </div>
  );
};
